
import loadable from "../../utils/loadable"

const LoadDefaultPage = loadable(() => import('../home/DefaultPage'));
const LoadAgreement = loadable(() => import('../home/Agreement'));
export default {
  path: '/',
  name: 'Home',
  childRoutes: [
    {
      path: 'default-page',
      name: 'Default page',
      component: LoadDefaultPage,
      isIndex: true,
    },
    { path: '/agreement', name: 'Agreement', component: LoadAgreement },
  ],
};



// WEBPACK FOOTER //
// ./src/features/home/route.js